(function ($) {
    class W4D_DialogManager {
        constructor() {
            this.initSelectors();
            this.bindEvents();
            this.justOpened = new Set();
            this.resizeTimeout = null;
        }

        initSelectors() {
            // Support both dialog and modal selectors
            this.dialogSelector = 'dialog[data-dialog], dialog[data-modal]';
        }

        hasOpenDialogs() {
            return $('dialog[data-dialog][open]').length > 0;
        }

        handleResize() {
            // Clear any existing timeout
            if (this.resizeTimeout) {
                clearTimeout(this.resizeTimeout);
            }

            // Only proceed if there are open dialogs
            if (!this.hasOpenDialogs()) {
                return;
            }

            // Set new timeout to throttle resize events
            this.resizeTimeout = setTimeout(() => {
                // console.log('Checking dialog positions after resize');

                // Reposition all open regular dialogs
                $('dialog[data-dialog][open]').each((index, dialog) => {
                    const dialogId = $(dialog).attr('data-dialog');
                    // Try to find the trigger element for this dialog
                    const triggerElement = document.querySelector(`[data-dialog-open="${dialogId}"], [data-modal-open="${dialogId}"]`);

                    if (triggerElement) {
                        this.repositionOpenDialog(dialog, triggerElement);
                    }
                });
            }, 100); // 100ms throttle
        }

        repositionOpenDialog(dialog, triggerElement) {
            // Get viewport dimensions
            const viewport = {
                width: window.innerWidth,
                height: window.innerHeight
            };

            // Container padding consideration
            const containerPadding = 20;

            // Get dialog's CURRENT position and dimensions (don't touch it!)
            const dialogRect = dialog.getBoundingClientRect();

            // Check if dialog fits in its CURRENT position
            const currentFitsLeft = dialogRect.left >= containerPadding;
            const currentFitsBottom = dialogRect.top + dialogRect.height <= (viewport.height - containerPadding);

            /*console.log(`Dialog ${dialog.getAttribute('data-dialog')} - current position fits:`, {
                fitsLeft: currentFitsLeft,
                fitsBottom: currentFitsBottom
            });*/

            // We need to know if the NATURAL position would fit to decide if we should reset
            // But we can calculate this without actually moving the dialog
            // We need the trigger position to calculate where natural position would be
            const triggerRect = triggerElement.getBoundingClientRect();
            const naturalTop = triggerRect.bottom + 20; // 20px spacing like CSS

            // For left, we need to know the dialog's natural left position
            // This is tricky without actually resetting... we need to store this or calculate it differently

            // Simple approach: check if we have any positioning styles applied
            const hasCustomLeft = dialog.style.left !== '';
            const hasCustomTop = dialog.style.top !== '';

            // If no custom positioning and it fits, do nothing
            if (!hasCustomLeft && !hasCustomTop && currentFitsLeft && currentFitsBottom) {
                // console.log('Dialog is in natural position and fits, no changes needed');
                return;
            }

            // If dialog has custom positioning, check if natural position would fit now
            if (hasCustomLeft || hasCustomTop) {
                const naturalFitsBottom = naturalTop + dialogRect.height <= (viewport.height - containerPadding);

                // If natural position would fit, reset to natural
                if (naturalFitsBottom) {
                    dialog.style.left = '';
                    dialog.style.top = '';
                    // console.log('Reset to natural position - natural position now fits');
                    return;
                }
            }

            // Apply positioning only if current position doesn't fit
            if (!currentFitsLeft) {
                dialog.style.left = 0;
            }

            if (!currentFitsBottom) {
                const spacing = 20;
                const adjustedTop = -(dialogRect.height + spacing);
                dialog.style.top = `${adjustedTop}px`;
            }
        }

        /**
         * Position a dialog relative to its trigger button
         */
        positionDialog(dialog, triggerElement) {

            // Get the trigger button's position relative to the viewport
            const triggerRect = triggerElement.getBoundingClientRect();

            // Get viewport dimensions
            const viewport = {
                width: window.innerWidth,
                height: window.innerHeight
            };

            // Container padding consideration
            const containerPadding = 20;

            // Temporarily show the dialog to measure it and get its natural CSS position
            const wasAlreadyOpen = dialog.open;

            if (!wasAlreadyOpen) {
                dialog.style.visibility = 'hidden';
                dialog.show();
            }

            // Get dialog dimensions and its natural CSS position
            const dialogRect = dialog.getBoundingClientRect();

            // Use the dialog's natural CSS position as our baseline
            const naturalLeft = dialogRect.left;
            const naturalTop = dialogRect.top;

            // Check if dialog fits in viewport (accounting for container padding)
            const fitsLeft = naturalLeft >= containerPadding; // 20px from left edge
            const fitsBottom = naturalTop + dialogRect.height <= (viewport.height - containerPadding); // 20px from bottom edge

            // console.log('Natural position:', { left: naturalLeft, top: naturalTop });
            // console.log('Fits in viewport (with padding):', { fitsLeft, fitsBottom });

            // Only adjust positions that need adjustment
            if (!fitsLeft) {
                dialog.style.left = 0;
            }

            if (!fitsBottom) {
                // Position dialog above by moving it up by its height + spacing
                const spacing = 20;
                const adjustedTop = -(dialogRect.height + spacing);
                dialog.style.top = `${adjustedTop}px`;
                // console.log('Adjusted top position to (relative):', adjustedTop);
            }

            if (fitsLeft && fitsBottom) {
                // console.log('Dialog fits naturally, no positioning needed');
            }

            // If we temporarily opened it, close it again
            if (!wasAlreadyOpen) {
                dialog.close();
                dialog.style.visibility = '';
            }
        }

        /**
         * Open a dialog with proper positioning
         */
        openDialog(dialog, triggerElement, isModal) {
            if (isModal || dialog.hasAttribute('data-dialog-modal')) {
                dialog.showModal();
            } else {
                // For regular dialogs, position them relative to the trigger
                this.positionDialog(dialog, triggerElement);
                dialog.show();

                // Track as just opened to prevent immediate closing
                this.justOpened.add(dialog);
                setTimeout(() => {
                    this.justOpened.delete(dialog);
                }, 100);
            }
        }

        bindEvents() {
            // Open dialog (modal or non-modal) - handle toggle buttons
            $(document).on('click', '[data-dialog-open][data-dialog-close], [data-modal-open][data-dialog-close]', (e) => {
                e.preventDefault();
                e.stopPropagation();

                const $trigger = $(e.currentTarget);
                const triggerElement = e.currentTarget;

                // Check which type of trigger this is for opening
                const isModal = $trigger.is('[data-modal-open]');
                const openId = isModal ? $trigger.data('modal-open') : $trigger.data('dialog-open');
                const closeId = $trigger.data('dialog-close');

                // Assuming they're the same dialog for toggle functionality
                const dialogId = openId || closeId;

                // Try both selectors to find the dialog
                let dialog = document.querySelector(`[data-modal="${dialogId}"]`);
                if (!dialog) {
                    dialog = document.querySelector(`[data-dialog="${dialogId}"]`);
                }

                if (!dialog) return;

                if (dialog.open) {
                    dialog.close();
                } else {
                    this.openDialog(dialog, triggerElement, isModal);
                }
            });

            // Handle buttons with only open attribute - support both types
            $(document).on('click', '[data-dialog-open]:not([data-dialog-close]), [data-modal-open]:not([data-dialog-close])', (e) => {
                e.preventDefault();
                e.stopPropagation();

                const $trigger = $(e.currentTarget);
                const triggerElement = e.currentTarget;

                // Check which type of trigger this is
                const isModal = $trigger.is('[data-modal-open]');
                const dialogId = isModal ? $trigger.data('modal-open') : $trigger.data('dialog-open');

                // Try both selectors to find the dialog
                let dialog = document.querySelector(`[data-modal="${dialogId}"]`);
                if (!dialog) {
                    dialog = document.querySelector(`[data-dialog="${dialogId}"]`);
                }

                if (!dialog) return;

                this.openDialog(dialog, triggerElement, isModal);
            });

            // Handle close buttons - only data-dialog-close exists
            $(document).on('click', '[data-dialog-close]:not([data-dialog-open]):not([data-modal-open])', (e) => {
                e.preventDefault();
                const dialogId = $(e.currentTarget).data('dialog-close');

                // Try both selectors to find the dialog
                let dialog = document.querySelector(`[data-modal="${dialogId}"]`);
                if (!dialog) {
                    dialog = document.querySelector(`[data-dialog="${dialogId}"]`);
                }

                if (dialog && dialog.open) {
                    dialog.close();
                }
            });

            // Handle clicks on modal backdrop to close modals (light dismiss for modals)
            $(document).on('click', 'dialog[data-modal]', (e) => {
                const dialog = e.currentTarget;

                // Only close if clicking on the dialog element itself (backdrop), not its content
                if (e.target === dialog) {
                    dialog.close();
                    // console.log("Modal closed by clicking backdrop");
                }
            });

            // Close all open dialogs on Escape
            $(document).on('keydown', (e) => {
                if (e.key === 'Escape') {
                    $(this.dialogSelector + '[open]').each(function () {
                        this.close();
                    });
                }
            });

            // Close regular dialogs when clicking outside (not modals)
            $(document).on('click', (e) => {
                const $target = $(e.target);

                // Don't close if clicking on any trigger button
                if ($target.closest('[data-dialog-open], [data-dialog-close], [data-modal-open]').length > 0) {
                    return;
                }

                // Don't close if clicking inside any open dialog
                if ($target.closest(this.dialogSelector + '[open]').length > 0) {
                    return;
                }

                // Close only regular dialogs that weren't just opened
                $('dialog[data-dialog][open]:not([data-dialog-modal])').each((index, dialog) => {
                    if (!this.justOpened.has(dialog)) {
                        dialog.close();
                        // console.log("Dialog closed by clicking outside");
                    }
                });
            });

            $(window).on('resize', () => {
                this.handleResize();
            });
        }
    }

    $(document).ready(() => {
        new W4D_DialogManager();
    });
})(jQuery);